import React, { useState } from 'react';

import { Grid } from '@material-ui/core';
import { makeStyles /*useTheme*/ } from '@material-ui/core/styles';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useInView } from 'react-intersection-observer';

import Episode1 from './episode1/Episode1';
import Episode1Video from './episode1/Episode1Video';
import CollageSection from './episode1/CollageSection';
import Episode2 from './episode2/Episode2';
import Episode2Collage from './episode2/Episode2Collage';
import Episode2Video from './episode2/Episode2Video';
import Episode3 from './episode3/Episode3';
import Episode3Collage from './episode3/Episode3Collage';
import Episode3Video from './episode3/Episode3Video';
import Episode4 from './episode4/Episode4';
import Episode4Collage from './episode4/Episode4Collage';
import Episode4Video from './episode4/Episode4Video';
import Episode5 from './episode5/Episode5';
import Episode5Collage from './episode5/Episode5Collage';
import Episode5Video from './episode5/Episode5Video';
import Episode6 from './episode6/Episode6';
import Episode6Collage from './episode6/Episode6Collage';
import Episode6Video from './episode6/Episode6Video';

import indicatorEpisodes from '../assets/indicatorEpisodes.svg';

import active1 from '../assets/active1.svg';
import active2 from '../assets/active2.svg';
import active3 from '../assets/active3.svg';
import active4 from '../assets/active4.svg';
import active5 from '../assets/active5.svg';
import active6 from '../assets/active6.svg';

import inactive1 from '../assets/inactive1.svg';
import inactive2 from '../assets/inactive2.svg';
import inactive3 from '../assets/inactive3.svg';
import inactive4 from '../assets/inactive4.svg';
import inactive5 from '../assets/inactive5.svg';
import inactive6 from '../assets/inactive6.svg';

import unreleased4 from '..//assets/unreleased4.svg';
import unreleased5 from '..//assets/unreleased5.svg';
import unreleased6 from '..//assets/unreleased6.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative'
  },
  indicatorCont: {
    position: 'fixed',
    top: '40vh',
    left: '2vw',
    width: '4rem',
    zIndex: 10,
    [theme.breakpoints.down('md')]: {
      left: '1.5vw'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  ep: {
    color: '#fff',
    fontFamily: 'NeuePlakR',
    fontSize: '1rem'
  },
  num: {
    color: '#fff',
    fontFamily: 'NeuePlakR',
    fontSize: '.8rem'
  },
  numBold: {
    color: '#BFDA1C',
    fontFamily: 'NeuePlakB',
    fontSize: '1rem'
  }
}));

const indicators = [
  {
    key: 1,
    number: '1',
    activeIcon: active1,
    inactiveIcon: inactive1,
    released: true,
    link: '#alabama'
  },
  {
    key: 2,
    number: '2',
    activeIcon: active2,
    inactiveIcon: inactive2,
    released: true,
    link: '#northCarolina'
  },
  {
    key: 3,
    number: '3',
    activeIcon: active3,
    inactiveIcon: inactive3,
    released: true,
    link: '#virginia'
  },
  {
    key: 4,
    number: '4',
    activeIcon: active4,
    inactiveIcon: inactive4,
    unreleased: unreleased4,
    released: true,
    link: '#georgia'
  },
  {
    key: 5,
    number: '5',
    activeIcon: active5,
    inactiveIcon: inactive5,
    unreleased: unreleased5,
    released: true,
    link: '#tennessee'
  },
  {
    key: 6,
    number: '6',
    activeIcon: active6,
    inactiveIcon: inactive6,
    unreleased: unreleased6,
    released: true,
    link: '#mississippi'
  }
];

const EpisodesMain = () => {
  const classes = useStyles();
  // const theme = useTheme();
  // const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [active, setActive] = useState(0);
  const { ref, inView } = useInView({ threshold: 0.05 });

  return (
    <Grid container className={classes.wrapper}>
      {inView ? (
        <Grid container alignItems="center" className={classes.indicatorCont}>
          <Grid item style={{ width: '1rem' }}>
            <img src={indicatorEpisodes} alt="graphic that says episodes" />
          </Grid>
          <Grid container direction="column" alignItems="center" style={{ width: '3rem' }}>
            {indicators.map((ind) => (
              <a href={ind.link} key={ind.key}>
                <img
                  src={
                    active === ind.key && ind.released === true
                      ? ind.activeIcon
                      : ind.released === false
                      ? ind.unreleased
                      : ind.inactiveIcon
                  }
                  alt="indicator number"
                  style={{ margin: '.8rem 0' }}
                />
              </a>
            ))}
          </Grid>
        </Grid>
      ) : null}
      <Grid ref={ref} container className={classes.videoSection}>
        <Episode1 active={active} setActive={setActive} />
        <Episode1Video />
        <CollageSection />
        <Episode2 active={active} setActive={setActive} />
        <Episode2Video />
        <Episode2Collage />
        <Episode3 active={active} setActive={setActive} />
        <Episode3Video />
        <Episode3Collage />
        <Episode4 active={active} setActive={setActive} />
        <Episode4Video />
        <Episode4Collage />
        <Episode5 active={active} setActive={setActive} />
        <Episode5Video />
        <Episode5Collage />
        <Episode6 active={active} setActive={setActive} />
        <Episode6Video />
        <Episode6Collage />
      </Grid>
    </Grid>
  );
};

export default EpisodesMain;
